import {
  EyeFilled,
  DollarOutlined,
  ShoppingOutlined,
  CalendarOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { AButton, AModal } from '../../../components';
import { IInventoryEntry } from '../../../shared/interfaces';
import { formatDate } from '../../../shared/utils/format-date';
import { Card, Row, Col, Space, Statistic, Typography } from 'antd';

const { Text } = Typography;

interface IInventoryViewProps {
  open: boolean;
  close: () => void;
  entry: IInventoryEntry | null;
}

const InventoryEntryView: React.FC<IInventoryViewProps> = ({
  open,
  close,
  entry,
}) => {
  const totalValue = (entry?.quantity || 0) * (entry?.value || 0);

  return (
    <AModal
      open={open}
      close={close}
      title={
        <>
          <EyeFilled style={{ color: '#1677ff', fontSize: 20 }} /> Detalhes da
          Entrada
        </>
      }
      footer={<AButton onClick={close}>Fechar</AButton>}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Card
          type="inner"
          title={
            <Space>
              <CalendarOutlined style={{ color: '#1890ff' }} />
              <span>Data</span>
            </Space>
          }
        >
          <Text>{formatDate(entry?.date)}</Text>
        </Card>
        <Card
          type="inner"
          title={
            <Space>
              <ShoppingOutlined style={{ color: '#52c41a' }} />
              <span>Produto</span>
            </Space>
          }
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            <Text strong style={{ fontSize: 16 }}>
              {entry?.product_name}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              ID: {entry?.product_id}
            </Text>
          </Space>
        </Card>
        {entry?.supplier_name && (
          <Card
            type="inner"
            title={
              <Space>
                <ShoppingOutlined style={{ color: '#faad14' }} />
                <span>Fornecedor</span>
              </Space>
            }
          >
            <Text>{entry?.supplier_name}</Text>
          </Card>
        )}
        <Card
          type="inner"
          title={
            <Space>
              <DollarOutlined style={{ color: '#eb2f96' }} />
              <span>Quantidade e Valores</span>
            </Space>
          }
        >
          <Row gutter={24}>
            <Col span={8}>
              <Statistic
                title="Quantidade"
                value={entry?.quantity || 0}
                valueStyle={{ color: '#1890ff' }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="Preço Unitário"
                value={entry?.value || 0}
                prefix="R$ "
                precision={2}
                valueStyle={{ color: '#52c41a' }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="Valor Total"
                value={totalValue}
                prefix="R$ "
                precision={2}
                valueStyle={{ color: '#eb2f96', fontSize: 18 }}
              />
            </Col>
          </Row>
        </Card>
        {entry?.observation && (
          <Card
            type="inner"
            title={
              <Space>
                <FileTextOutlined style={{ color: '#13c2c2' }} />
                <span>Observação</span>
              </Space>
            }
          >
            <Text>{entry?.observation}</Text>
          </Card>
        )}
        <Card type="inner" size="small" style={{ background: '#fafafa' }}>
          <Space direction="vertical" style={{ fontSize: 12, width: '100%' }}>
            <Text type="secondary">Criado em: {formatDate(entry?.date)}</Text>
          </Space>
        </Card>
      </Space>
    </AModal>
  );
};
export default InventoryEntryView;
